import React from 'react';

const DefaultHeroBanner = ({ style }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="36" 
    height="24" 
    viewBox="0 0 36 24" 
    fill="none" 
    style={style}
  >
    <path d="M2.95679 22.1398V7.1853H33.0436V22.1398" stroke="#181818" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.22998 22.1402V12.7703H20.7219V22.1402" stroke="#181818" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M1.80005 7.125H34.2001" stroke="#181818" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M30.0888 22.1404V14.3982H26.1058V22.1404" stroke="#181818" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.22998 14.6631H20.7219" stroke="#181818" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.22998 16.5312H20.7219" stroke="#181818" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.22998 18.4004H20.7219" stroke="#181818" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.22998 20.2686H20.7219" stroke="#181818" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18.3745 0.75H10.1904C9.85601 0.75 9.58496 1.02907 9.58496 1.37332V3.96165C9.58496 4.3059 9.85601 4.58497 10.1904 4.58497H18.3745C18.7088 4.58497 18.9799 4.3059 18.9799 3.96165V1.37332C18.9799 1.02907 18.7088 0.75 18.3745 0.75Z" stroke="#181818" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.2928 5.33545V6.53539" stroke="#181818" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17.467 5.33545V6.53539" stroke="#181818" strokeLinecap="round" strokeLinejoin="round"/>
    <rect y="22.998" width="36" height="1.00119" fill="#181818"/>
  </svg>
);

export default DefaultHeroBanner;